// extracted by mini-css-extract-plugin
export default {"container":"_3kCTE___Toggle-module__container","input":"Yu-79___Toggle-module__input","label":"wLzuj___Toggle-module__label","large":"mh88k___Toggle-module__large"};